import axios from "axios";


axios.interceptors.request.use(
    (request) => {
        request.baseURL = process.env.REACT_APP_API_GATEWAY;
        return request;
    }
);

axios.interceptors.response.use(
    (response) => {
        // Başarılı bir cevap geldiğinde isSuccess true olacak şekilde Result<T> döndürürüz
        return response;
    },
    (error) => {
        // Hata olduğunda isSuccess false ve errors dizisi dolu olacak şekilde Result<T> döndürürüz
        return Promise.reject(error);
    }
);
export default axios;

const axiosApi = axios.create({ baseURL: process.env.REACT_APP_API_GATEWAY });

axiosApi.interceptors.request.use(
    (request) => {
        request.headers.Authorization = `Bearer ${localStorage.getItem("jwtToken")}`
        return request;
    },
);


export { axiosApi };